import styled from "@emotion/styled"
import { shouldForwardProp } from "src/common/shouldForwardProp"

export const ColorIndicator = styled("div", { shouldForwardProp })<{ $color: string; $size: number }>`
	min-width: ${({ $size }) => `${$size}px`};
	width: ${({ $size }) => `${$size}px`};
	min-height: ${({ $size }) => `${$size}px`};
	height: ${({ $size }) => `${$size}px`};
	border-radius: 50%;
	background: ${({ $color }) => `${$color}`};
`
